var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 218 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_11900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.7 138.7L156.2 97L130.7 138.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7 55.2998L156.2 96.9998L189.4 42.6998L171.3 11.3998C167.3 4.49981 160 0.299805 152 0.299805H121L87.3 55.2998H130.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7 138.7H87.3L120.9 193.7H152C159.9 193.7 167.3 189.5 171.3 182.6L189.4 151.2L156.2 97L130.7 138.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3 55.2998L121 0.299805H66C58.1 0.299805 50.7 4.49981 46.7 11.3998L21.3 55.2998H87.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3 85.8997L189.4 42.6997L156.2 96.9997L189.4 151.3L214.3 108.2C218.3 101.2 218.3 92.7997 214.3 85.8997Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3 138.7H21.4L46.8 182.6C50.8 189.5 58.1 193.7 66.1 193.7H121L87.3 138.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8 96.9998L87.3 55.2998H21.4L3.70001 85.8998C-0.299988 92.7998 -0.299988 101.3 3.70001 108.1L21.4 138.7H87.3L61.8 96.9998Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_11900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 194,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAdmin);
export default __webpack_public_path__ + "static/media/Google_Admin.2ee5ec3f62b055736bf4a4e4220e9926.svg";
export { ForwardRef as ReactComponent };